import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CreatorFanList from './creatorFanList';
import { useQuery } from '@tanstack/react-query';
import { fetchFanList } from '../../utils/api';
import { useProfileData } from '../../hooks/useProfileData';

const UserStreaksData: React.FC = () => {
  const { creatorProfileData: profileData, isLoadingProfile } = useProfileData();
  const { userId = '' } = profileData || {};

  const { data: allStreaksData, isLoading } = useQuery({
    queryKey: ['creators-all-streaks', userId],
    queryFn: async () => {
      return fetchFanList(userId, 25);
    },
    staleTime: Infinity,
    enabled: !!userId,
  });

  if (isLoadingProfile || isLoading) {
    return <></>
  }

  return (
    (!!allStreaksData && !!allStreaksData.length) ?
        <Box width="100%" paddingTop="32px">
          <Typography
            component="p"
            variant="body2"
            color="text.secondary"
            sx={{ userSelect: 'text' }}
          >
            Fans
          </Typography>
          <CreatorFanList userStreaksData={allStreaksData} />
        </Box> :
        <></> // skip if no data
  );
}

export default UserStreaksData;
